import { useMemo, useState } from 'react';
import { FlatList, Pressable, Text, View } from 'react-native';
import { Field, Sheet } from './ui';
import { C, alpha } from './theme';
import { caminhoFuso, fusoAparelho, listaFusos, nomeFuso, rotuloGMT } from '../lib/fuso';
import { norm } from '../lib/date';
import { t } from '../lib/i18n';

/** Escolha do fuso horário de um agendamento (todos os fusos do mundo, com busca). */
export function FusoSheet({ visible, valor, cor, onClose, onPick }: { visible: boolean; valor: string; cor: string; onClose: () => void; onPick: (tz: string) => void }) {
  const [busca, setBusca] = useState('');
  const todos = useMemo(() => (visible ? listaFusos().map(tz => ({ tz, txt: norm(`${tz} ${caminhoFuso(tz)} ${rotuloGMT(tz)}`) })) : []), [visible]);
  const meu = fusoAparelho();
  const q = norm(busca.trim());
  const lista = todos.filter(x => !q || x.txt.includes(q)).sort((a, b) => (a.tz === meu ? -1 : b.tz === meu ? 1 : a.tz.localeCompare(b.tz)));
  return (
    <Sheet visible={visible} onClose={onClose} title={t('Fuso horário')}>
      <View style={{ paddingHorizontal: 16, gap: 8, paddingBottom: 8 }}>
        <Field value={busca} onChangeText={setBusca} placeholder={t('Buscar cidade, país ou GMT')} autoCorrect={false} />
        <Text style={{ color: C.sub, fontSize: 12 }}>{t('A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.')}</Text>
      </View>
      <FlatList data={lista} keyExtractor={x => x.tz} keyboardShouldPersistTaps="handled" contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 60 }}
        renderItem={({ item }) => (
          <Pressable onPress={() => { onPick(item.tz); onClose(); }}
            style={({ pressed }) => ({ padding: 12, borderRadius: 12, backgroundColor: item.tz === valor ? alpha(cor, 0.2) : pressed ? C.card2 : 'transparent' })}>
            <Text style={{ color: C.text, fontWeight: item.tz === valor ? '800' : '500' }}>{nomeFuso(item.tz)}{item.tz === meu ? ` · ${t('este dispositivo')}` : ''}</Text>
            <Text style={{ color: C.mute, fontSize: 11 }}>{caminhoFuso(item.tz)}</Text>
          </Pressable>
        )} />
    </Sheet>
  );
}
